/**
 * Danh muc task type.
 *
 * Chia lam hai nhom, va su khac biet giua chung la nen tang cua NON-GOALS (muc 3):
 *   - Nhom "giai duoc tai cho": dap an nam trong chinh du lieu client gui len (anh, cau hoi).
 *   - Nhom "token": dap an do SERVER CUA VENDOR cap sau khi cham IP + fingerprint + hanh vi.
 *     capforge KHONG bao gio tu giai nhom nay — chi dinh tuyen sang upstream neu nguoi dung bat.
 */
/** Task ma solver noi bo co the (hoac se) xu ly. */
export const LOCAL_TASK_TYPES = [
    'ImageToTextTask',
    'TextCaptchaTask',
    'GridTask',
    'CoordinatesTask',
    'RotateTask',
    'BoundingBoxTask',
    'DrawAroundTask',
];
/**
 * Task dang token cua vendor lon. Chi passthrough len upstream, KHONG tu giai.
 * Danh sach nay dung de tra loi som ERROR_CAPTCHA_UNSOLVABLE khi upstream tat,
 * thay vi de dispatcher chay long vong roi cung that bai.
 */
export const TOKEN_TASK_TYPES = [
    'RecaptchaV2Task',
    'RecaptchaV2TaskProxyless',
    'RecaptchaV2EnterpriseTask',
    'RecaptchaV2EnterpriseTaskProxyless',
    'RecaptchaV3Task',
    'RecaptchaV3TaskProxyless',
    'RecaptchaV3Enterprise',
    'HCaptchaTask',
    'HCaptchaTaskProxyless',
    'TurnstileTask',
    'TurnstileTaskProxyless',
    'AntiAwsWafTask',
    'AntiAwsWafTaskProxyless',
    'AntiImpervaTask',
    'AntiImpervaTaskProxyless',
    'DataDomeSliderTask',
    'GeeTestTask',
    'GeeTestTaskProxyless',
    'FunCaptchaTask',
    'FunCaptchaTaskProxyless',
    'MtCaptchaTask',
    'MtCaptchaTaskProxyless',
    'TenDITask',
    'YandexSmartCaptchaTask',
    'YandexSmartCaptchaTaskProxyless',
    'KeyCaptchaTask',
    'KeyCaptchaTaskProxyless',
    'CapyTask',
    'CapyTaskProxyless',
    'LeminTask',
    'LeminTaskProxyless',
    'CutCaptchaTask',
    'CutCaptchaTaskProxyless',
    'CyberSiAraTask',
    'CyberSiAraTaskProxyless',
    'AmazonTask',
    'AmazonTaskProxyless',
    'PrsopoTask',
    'ProsopoTask',
    'ProsopoTaskProxyless',
    'FriendlyCaptchaTask',
    'FriendlyCaptchaTaskProxyless',
    'AtbCaptchaTask',
    'AtbCaptchaTaskProxyless',
];
const TOKEN_TASK_TYPE_SET = new Set(TOKEN_TASK_TYPES);
const LOCAL_TASK_TYPE_SET = new Set(LOCAL_TASK_TYPES);
export function isTokenTaskType(type) {
    return TOKEN_TASK_TYPE_SET.has(type);
}
export function isLocalTaskType(type) {
    return LOCAL_TASK_TYPE_SET.has(type);
}
/**
 * Task type noi bo cua capforge cho nhom proof-of-work (Altcha / Friendly / Prosopo PoW).
 * 2Captcha khong co task type tuong duong, nen day la ten RIENG cua capforge:
 * chi dung o duong noi bo va API native, KHONG bao gio gui len upstream.
 */
export const POW_TASK_TYPE = 'CapforgePowTask';
/** Ten than thien cua API native (muc 6.2). */
export const NATIVE_TYPES = ['image', 'text', 'grid', 'rotate', 'pow'];
/** Anh xa ten native -> task type 2Captcha (hoac task type noi bo cho `pow`). */
export const NATIVE_TO_TASK_TYPE = {
    image: 'ImageToTextTask',
    text: 'TextCaptchaTask',
    grid: 'GridTask',
    rotate: 'RotateTask',
    pow: POW_TASK_TYPE,
};
/** Anh xa nguoc, de hien ten than thien tren dashboard. */
export const TASK_TYPE_TO_NATIVE = {
    ImageToTextTask: 'image',
    TextCaptchaTask: 'text',
    GridTask: 'grid',
    CoordinatesTask: 'grid',
    RotateTask: 'rotate',
    [POW_TASK_TYPE]: 'pow',
};
//# sourceMappingURL=taskTypes.js.map